<template>
  <div class="row">
    <div class="col-lg-8 col-md-12">
      <edit-profile-form v-bind:user="user"> </edit-profile-form>
    </div>

    <div class="col-lg-4 col-md-6">
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-sm-3">
              <img
                :src="user.avatarUrl"
                alt="avatar"
                class="img img-fluid rounded-circle"
              />
            </div>
            <div class="col-sm-9">
              <h4 class="title">
                {{ user.displayName }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <table class="table">
            <tbody>
              <tr>
                <th>Joined</th>
                <td>
                  <time :datetime="user.createdAt">
                    {{ user.createdAt | moment("from", "now") }}
                  </time>
                </td>
              </tr>
              <tr>
                <th>Updated</th>
                <td>
                  <time :datetime="user.updatedAt">
                    {{ user.updatedAt | moment("from", "now") }}
                  </time>
                </td>
              </tr>
              <tr>
                <th>Role</th>
                <td>{{ user.role }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditProfileForm from "./UserProfile/EditProfileForm.vue";

export default {
  components: {
    EditProfileForm
  },
  computed: {
    user: function() {
      return this.$auth.user();
    }
  }
};
</script>
<style></style>
